import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import SidebarContent from "./SideBarContent";

function AppSidebar({ drawerWidth, mobileOpen, handleDrawerClose }) {
  const [searchTerm, setSearchTerm] = useState("");

  const contentProps = { searchTerm, setSearchTerm };

  const drawer_style = {
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      width: 270,
    },
  };

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
    >
      <Drawer
        className="muidrawer"
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerClose}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "270px",
          },
        }}
      >
        <SidebarContent {...contentProps} />
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          ...drawer_style,
        }}
        open
      >
        <SidebarContent {...contentProps} />
      </Drawer>
    </Box>
  );
}

export default AppSidebar;
